var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.notification ? _c('div', [_c('v-divider', {
    staticClass: "grey darken-4"
  }), _c('div', {
    staticClass: "pa-12px py-md-14px grey lighten-4"
  }, [_c('strong', {
    staticClass: "font-size-16"
  }, [_vm._v(_vm._s(_vm.notification.subject))])]), _c('v-divider'), _c('div', {
    staticClass: "pa-12px py-md-14px"
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_c('strong', {
    staticClass: "font-weight-medium"
  }, [_vm._v("작성일자 : ")]), _vm._v(_vm._s(_vm.$dayjs(_vm.notification.createdAt).format("YYYY-MM-DD HH:mm:ss")))])]), _c('v-divider'), _c('div', {
    staticClass: "font-size-14 font-size-md-16 pa-12px py-20px min-h-200px"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.notification.content)
    }
  })]), _c('v-divider'), _vm.prevNotification ? [_c('div', {
    staticClass: "pa-12px py-md-14px grey lighten-4"
  }, [_c('v-row', {
    staticClass: "row--small font-size-14 font-size-md-16"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b', [_vm._v("이전글")]), _c('v-icon', {
    staticClass: "ml-8px",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/center/notifications/".concat(_vm.prevNotification._id)
    }
  }, [_vm._v(_vm._s(_vm.prevNotification.subject))])], 1)], 1)], 1), _c('v-divider')] : _vm._e(), _vm.nextNotification ? [_c('div', {
    staticClass: "pa-12px py-md-14px grey lighten-4"
  }, [_c('v-row', {
    staticClass: "row--small font-size-14 font-size-md-16"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b', [_vm._v("다음글")]), _c('v-icon', {
    staticClass: "ml-8px",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/center/notifications/".concat(_vm.nextNotification._id)
    }
  }, [_vm._v(_vm._s(_vm.nextNotification.subject))])], 1)], 1)], 1), _c('v-divider')] : _vm._e()], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }